import React from 'react';


class Footer extends React.Component {
  render() {
    return (
      <footer className="footer text-center">
        All Rights Reserved by Package Assistant.
        {/*Designed and Developed by{' '}*/}
        {/*<a href="https://wrappixel.com">WrapPixel</a>.*/}
      </footer>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/footer.jsx